module.exports = __webpack_public_path__ + "img/logo_icon_01.f6a55c3.svg";